import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Login from './views/Login'
import Register from './views/Register'
import Statistic from './views/Statistic'
import Conversion from './views/Conversion'
import Stream from './views/Stream'
import Offer from './views/Offer'
import OfferView from './views/OfferView'
import News from './views/News'
import Profile from './views/Profile'
import Payment from './views/Payment'
import Ticket from './views/Ticket'
import Help from './views/Help'
import TicketMessage from './views/TicketMessage'
import PasswordRecovery from './views/PasswordRecovery'
import ResetPassword from './views/ResetPassword'
import Activation from './views/Activation'
import Confirmation from './views/Confirmation'
import Store from './views/Store'
import Referral from './views/Referral'
import Postback from './views/Postback'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'main',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/auth/:token',
        name: 'auth',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/password-recovery',
        name: 'password-recovery',
        component: PasswordRecovery,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPassword,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/statistic',
        name: 'statistic',
        component: Statistic,
        meta: {
            title: 'statistics',
            requiresAuth: true
        }
    },
    {
        path: '/conversions',
        name: 'conversions',
        component: Conversion,
        meta: {
            title: 'statistics',
            requiresAuth: true
        }
    },
    {
        path: '/streams',
        name: 'streams',
        component: Stream,
        meta: {
            title: 'streams',
            requiresAuth: true
        }
    },
    {
        path: '/offers',
        name: 'offers',
        component: Offer,
        meta: {
            title: 'offers',
            requiresAuth: true
        }
    },
    {
        path: '/offers/:id',
        name: 'offer-view',
        component: OfferView,
        meta: {
            title: 'offer',
            requiresAuth: true
        }
    },
    {
        path: '/news',
        name: 'news',
        component: News,
        meta: {
            title: 'news',
            requiresAuth: true
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            title: 'profile',
            requiresAuth: true
        }
    },
    {
        path: '/payments',
        name: 'payment',
        component: Payment,
        meta: {
            title: 'payments',
            requiresAuth: true
        }
    },
    {
        path: '/tickets',
        name: 'tickets',
        component: Ticket,
        meta: {
            title: 'support',
            requiresAuth: true
        }
    },
    {
        path: '/tickets/:id',
        name: 'ticket-messages',
        component: TicketMessage,
        meta: {
            title: 'support',
            requiresAuth: true
        }
    },
    {
        path: '/store',
        name: 'store',
        component: Store,
        meta: {
            title: 'store_gift',
            requiresAuth: true
        }
    },
    {
        path: '/referrals',
        name: 'referral',
        component: Referral,
        meta: {
            title: 'referrals',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'help',
        component: Help,
        meta: {
            title: 'help',
            requiresAuth: true
        }
    },
    {
        path: '/activation',
        name: 'activation',
        component: Activation,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/confirmation/:token',
        name: 'confirmation',
        component: Confirmation,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/postback',
        name: 'postback',
        component: Postback,
        meta: {
            title: 'postback_logs',
            requiresAuth: true
        }
    },
    {
        path: '/**',
        redirect: '/statistic'
    }
];

const router = new Router({
    routes,
    store,
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && store().getters.isAuthenticated) {
        next();
    } else if (requiresAuth && !store().getters.isAuthenticated) {
        next('/login');
    } else {
        next();
    }
});

export default router;
